import './Checkout.css';
import React, { useEffect } from 'react';

import { BASE_URL } from '../../config/environmentConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { flowType, useDemo } from '../../store/DemoContext';

interface Props {}

const CheckoutIframe: React.FC<Props> = () => {
  const {
    state: { flow },
  } = useDemo();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window?.addEventListener('message', function (event) {
      switch (event.data) {
        case 'decline-iframe':
          navigate('/demo/decline');
          break;
        case 'decline':
          navigate('/decline');
          break;
        case 'success':
          navigate('/success');
          break;
      }

      if (event?.data?.message === 'redirect' && event?.data?.url) {
        navigate(event?.data?.url);
      }
    });
  }, []);

  const getPathname = (flow: flowType): string => {
    switch (flow) {
      case flowType.challengeSuccess:
        return 'challenge-success';
      case flowType.challengeDecline:
        return 'challenge-decline';
      case flowType.noConsent:
        return 'no-consent';
      case flowType.frictionless:
        return 'frictionless';
      case flowType.challengeFrictionless:
        return 'challenge-frictionless';
      case flowType.consent:
      default:
        return 'consent';
    }
  };

  return (
    <div className="CheckoutIframe">
      <iframe
        data-cy="payment-frame"
        title="123456789"
        id={window?.location.href.includes('/checkout-iframe-sensejs') ? 'senseOnly' : 'bothWidgets'}
        src={
          location.pathname.includes('demo')
            ? `${window?.location.origin}/demo/iframe/${getPathname(flow)}/?id=123456789`
            : (BASE_URL.IFRAME_URL || '').replace(
                '123456789',
                window?.location.href.includes('/checkout-iframe-sensejs') ? 'senseOnly' : 'bothWidgets',
              )
        }
        frameBorder="0"
      />
    </div>
  );
};

export default CheckoutIframe;
